// Editorial fallback covers for events without an uploaded image.
// Reads from the single category source of truth in /lib/categories.js so
// adding a new category automatically gets its fallback wired everywhere.
import { resolveCategory, CATEGORY_BY_KEY } from "@/lib/categories";

const GENERIC = CATEGORY_BY_KEY.Other.fallbackImage;

export function defaultCoverFor(category) {
  if (!category) return GENERIC;
  return resolveCategory(category).fallbackImage || GENERIC;
}

/**
 * Resolve a cover image URL for an event.
 * If the host uploaded a cover_url it's used; otherwise we return the
 * category-mapped fallback. Empty string also counts as missing.
 */
export function coverFor(event) {
  const u = event?.cover_url;
  if (typeof u === "string" && u.trim().length > 0) return u;
  return defaultCoverFor(event?.category);
}
